<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="400"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="bg_box">
					<img src="../../../assets/img_public/about/qyjj/block01.webp" />
				</div>
				<div class="msg_box">
					<div class="txt">为全球提供 实惠 易用 精准 的诊断产品</div>
					<div class="tit1">库尔科技</div>
					<div class="tit2">运用现代生物工程技术和医学研究成果，为全球人类健康事业服务!</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">美国 CorDx Union 集团</div>
				<div class="txt">
					北京库尔科技有限公司为美国CorDx Union集团旗下子公司。CorDx Union(简称CU)成立于2006年，是综合研发、生产、营销、服务为一体的国际化集团公司，设有Accu News准信、Coretests库尔科技、Abiores佳宝瑞源、Jtests建英佳、Bonore保诺塑业、Cupet夕友新能源等品牌系，共21家子公司。
				</div>
				<div class="txt">
					CU以医疗器械&诊断试剂为主业，产品销往170多个国家和地区，在全球拥有上1亿用户，广泛应用于临床检验、基层医疗、现场执法、疫情监控、灾难救援、家庭自测及健康管理等领域。
				</div>
				<div class="txt">
					CU全球拥有四个研究院，布局于加州SD，北京大兴，河北雄安，中国海南岛，持续提升分子诊断、胶体金层析、荧光免疫、生物芯片、重组蛋白、mRNA疫苗、宠物用品、电池材料、Ai质量管理系统等科技创新平台。诊疗产品主要用于传染病、肿瘤、心脑血管、炎症、药物滥用等病症。CU制造基地总面积3万平米，同时也为医药同行提供优质服务。
				</div>
				<div class="txt">
					CU以“安全有效 使命必达”为宗旨，秉承“从有机到安息 全供应链服务”的愿景，充分运用现代生物工程技术和医学研究成果，打造超一流医药企业，热心公益，为全球健康事业服务!
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="bg_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img src="../../../assets/img_public/about/qyjj/block02.webp" />
				</div>
				<div class="msg_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="title">产品销往170多个国家和地区，在全球拥有上亿用户</div>
					<div class="info_el">
						<img src="../../../assets/img_public/index/icon1.webp" />
						<div class="info_info">
							<div class="info_info_box">
								<count-to :startVal="0" :endVal="170" :duration="6000" class="num"></count-to>
								<div class="add" style="right: 0;">+</div>
							</div>
							<div class="tit">市场覆盖国家及地区</div>
						</div>
					</div>
					<div class="info_el">
						<img src="../../../assets/img_public/index/icon2.webp" />
						<div class="info_info">
							<div class="info_info_box">
								<count-to :startVal="0" :endVal="1" :duration="6000" class="num"></count-to>
								<div class="add" style="left: 40px;">+</div>
								<div class="count" style="left: 40px;">亿</div>
							</div>
							<div class="tit">用户</div>
						</div>
					</div>
					<div class="info_el">
						<img src="../../../assets/img_public/index/icon3.webp" />
						<div class="info_info">
							<div class="info_info_box">
								<count-to :startVal="0" :endVal="50" :duration="6000" class="num"></count-to>
								<div class="add" style="right: 30px;">+</div>
							</div>
							<div class="tit">资质认证</div>
						</div>
					</div>
					<div class="info_el">
						<img src="../../../assets/img_public/index/icon4.webp" />
						<div class="info_info">
							<div class="info_info_box">
								<count-to :startVal="0" :endVal="3" :duration="6000" class="num"></count-to>
								<div class="add" style="left: 40px;font-size: 16px;">㎡</div>
								<div class="count" style="left: 40px;">万</div>
							</div>
							<div class="tit">产业基地面积</div>
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="swiper_s_box"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="500"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="swiper_s_main">
					<div
						v-if="imgData.length > 0"
						class="block_banner"
					>
						<div v-if="swiperIndex != 0" class="icon_left animate__animated animate__fadeInLeft" @click="bannerLeftClick">
							<van-icon name="arrow-left" color="#ffffff" size="20px" />
						</div>
						<div v-if="swiperIndex != swiperLength" class="icon_right animate__animated animate__fadeInRight" @click="bannerRightClick">
							<van-icon name="arrow" color="#ffffff" size="20px" />
						</div>
						<van-swipe
							class=""
							:loop="false"
							:autoplay="0"
							indicator-color="white"
							ref="swipeBox"
							:stop-propagation="false"
							:show-indicators="false"
							:width="530"
							@change="onChange"
						>
							<van-swipe-item v-for="(value, index) in imgData" :key="index">
								<div class="block_banner_el">
									<div class="mask_box">
										<div class="mask_box_main">
											<div class="tit_box">
												<div class="title">{{ value.title }}</div>
												<!-- <div class="btn" @click="showBigImg(value.image)">查看</div> -->
											</div>
										</div>
									</div>
									<img class="img_el" :src="value.image" @dragstart.prevent />
								</div>
							</van-swipe-item>
						</van-swipe>
					</div>
				</div>
			</div>
			<!--块4-->
		</div>
	</div>
</template>

<script>
import CountTo from 'vue-count-to';
import { ImagePreview } from 'vant';  //图片放大
export default {
	components:{
		CountTo
	},
	data() {
		return {
			imgData: [
				{ image: require('@/assets/img_public/about/qyjj/CJ_01.webp'), title: '工厂图' },
				{ image: require('@/assets/img_public/about/qyjj/CJ_02.webp'), title: '实验室图' },
				{ image: require('@/assets/img_public/about/qyjj/CJ_03.webp'), title: '科研图' }
			],
			swiperIndex: 0,
			swiperLength: 1,
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//点击查看大图
		showBigImg(value) {
			let that = this;
			ImagePreview({
				closeable: true,
				showIndicators: false,
				showIndex: false,
				images: [value]
			});
		},
		bannerLeftClick(value) {  //导航左侧按钮点击
			let that = this;
			that.$refs.swipeBox.prev();
		},
		bannerRightClick(value) {  //导航右侧按钮点击
			let that = this;
			that.$refs.swipeBox.next();
		},
		onChange(index) {
			let that = this;
			that.swiperIndex = index;
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//轮播
	.swiper_s_box{
		padding: 150px 0;
		background-color: #F7F6F9;
		.swiper_s_main{
			width: 1264px;
			margin: 0 auto;
			.block_banner{
				margin: 0 auto 0px auto;
				position: relative;
				.tit{
					margin-right: 50px;
					padding-top: 30px;
					text-align: center;
					font-size: 24px;
					color: #333333;
				}
				.block_banner_el{
					position: relative;
					color: #000000;
					padding: 20px;
					margin-right: 30px;
					background-color: #ffffff;
					.mask_box{
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						padding: 20px;
						.mask_box_main{
							display: none;
							width: 100%;
							height: 100%;
							background-color: rgba(0, 0, 0, 0.4);
							.tit_box{
								position: absolute;
								bottom: 50px;
								left: 50%;
								z-index: 1;
								transform: translate(-50%, 0);
								text-align: center;
								.btn{
									padding: 10px 50px;
									text-align: center;
									color: #ffffff;
									background: linear-gradient( 90deg, #CF0272 0%, #A20073 100%);
									border-radius: 8px 8px 8px 8px;
								}
								.title{
									padding-bottom: 12px;
									color: #ffffff;
									font-size: 20px;
								}
							}
						}
					}
					.mask_box:hover{
						.mask_box_main{
							display: block;
						}
					}
					.txt{
						padding-top: 30px;
					}
					.tit{
						padding: 10px 0 30px 0;
						font-size: 30px;
						font-weight: bold;
					}
					.img_el{
						width: 100%;
						border-radius: 10px;
					}
				}
				.icon_left{
					left: -100px;
				}
				.icon_right{
					right: -100px;
				}
				.icon_left, .icon_right{
					position: absolute;
					z-index: 1;
					top: 50%;
					margin-top: -18px;
					background: #333333;
					border-radius: 50%;
					width: 36px;
					height: 36px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}
			}
		}
	}
	//块3
	.block_3{
		position: relative;
		.msg_box{
			position: absolute;
			width: 1264px;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			.info_el{
				padding-top: 30px;
				.info_info{
					width: 360px;
					margin-left: 40px;
					padding: 0 0 25px 0px;
					display: inline-block;
					border-bottom: 1px solid #E3E1E6;
					.info_info_box{
						width: 120px;
						display: inline-block;
						position: relative;
						.count{
							position: absolute;
							bottom: 16px;
							font-size: 14px;
							line-height: 1;
							color: #A20073;
						}
						.add{
							position: absolute;
							top: 0;
							font-size: 24px;
							line-height: 1;
							color: #A20073;
						}
						.num{
							font-size: 62px;
							color: #A20073;
							line-height: 1;
						}
					}
					.tit{
						margin-left: 20px;
						display: inline-block;
						position: relative;
						top: -16px;
					}
				}
				img{
					width: 48px;
					height: 48px;
				}
			}
			.title{
				padding-bottom: 20px;
				font-size: 30px;
			}
		}
		.bg_box{
			width: 100%;
			img{
				width: 100%;
				min-width: 1264px;
			}
		}
	}
	//块2
	.block_2{
		width: 1264px;
		margin: 0 auto;
		margin: 0px auto;
		padding: 50px;
		box-shadow: 0px 0px 30px 1px rgba(0,0,0,0.1);
		border-radius: 12px 12px 12px 12px;
		.txt{
			padding-bottom: 10px;
			font-size: 18px;
			text-indent: 36px;
			line-height: 36px;
		}
		.tit{
			padding-bottom: 15px;
			font-size: 36px;
			color: #A50073;
		}
	}
	//块1
	.block_1{
		position: relative;
		.msg_box{
			position: absolute;
			width: 1264px;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			.tit2{
				font-size: 24px;
				color: #A50073;
			}
			.tit1{
				padding: 26px 0 20px 0;
				font-size: 46px;
			}
			.txt{
				font-size: 18px;
			}
		}
		.bg_box{
			width: 100%;
			img{
				width: 100%;
				min-width: 1264px;
			}
		}
	}
}
</style>